export default {
  DEV: 'http://localhost:1337',
  STAGING: 'https://pronostic-staging-back.herokuapp.com',
  PRODUCTION: 'https://pronostic-prod-back.herokuapp.com'
  // eslint-disable-next-line no-undef
}[process.env.REACT_APP_ENV || 'DEV'];
